// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos para el Mission Control Dashboard */
.device-card {
  /* Fondo oscuro y profundo de la sala de control */
  background-color: rgba(26, 26, 46, 0.8); /* Fondo semi-transparente */
  border: 1px solid #00f5ff;
  border-radius: 15px;
  padding: 20px;
  margin: 15px;
  width: calc(50% - 30px); /* Para dos tarjetas por fila */
  box-shadow: 0 0 15px rgba(0, 245, 255, 0.3), inset 0 0 10px rgba(0, 245, 255, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px); /* Prefijo para Safari */
  color: #ffffff;
  font-family: 'Share Tech Mono', monospace;
  transition: all 0.3s ease;
  position: relative;
}

.device-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 245, 255, 0.2);
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

.device-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-family: 'Share Tech Mono', monospace; /* Fuente tecnológica */
  text-shadow: 0 0 5px #00f5ff; /* Sutil brillo en el texto */
}

/* Indicador de estado LED parpadeante */
.status-indicator {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #ff3131; /* Rojo Fallo por defecto */
  box-shadow: 0 0 10px #ff3131;
}

.status-indicator.online {
  background-color: #39ff14; /* Verde Eléctrico */
  box-shadow: 0 0 15px #39ff14;
  animation: pulse 1.5s infinite; /* Animación de pulso para estado online */
}

.device-body p {
  margin: 0.5rem 0;
  font-size: 0.9rem;
  color: #ccc;
}

.device-body p span {
  font-weight: bold;
}

.device-body p span.online {
  color: #39ff14; /* Verde Eléctrico */
  text-shadow: 0 0 3px #39ff14;
}

.device-body p span.offline {
  color: #ff3131; /* Rojo Neón */
  text-shadow: 0 0 3px #ff3131;
}

.chart-container {
  margin-top: 1.5rem;
}

.chart-container h4 {
  margin-bottom: 15px;
  color: #00f5ff; /* Cian neón */
  text-align: center;
  font-weight: normal;
  text-shadow: 0 0 5px #00f5ff;
}

/* Animación de pulso para el indicador de estado */
@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(57, 255, 20, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 10px 10px rgba(57, 255, 20, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(57, 255, 20, 0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.device-simulation {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 2rem;
  align-items: flex-start;
}

.process-list h4, .cpu-chart h4 {
  color: #bbb;
  margin-bottom: 1rem;
}

.process-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.9rem;
}
.process-list li {
  padding: 0.2rem;
  border-bottom: 1px dashed #444;
}

@media (max-width: 900px) {
  .device-simulation {
    grid-template-columns: 1fr;
  }
}

.plan-status-placeholder {
  background: #1a1a2e;
  border: 1px solid rgba(0, 245, 255, 0.3);
  border-radius: 16px;
  padding: 1.5rem 1rem;
  display: flex;
  flex-direction: column; /* Apilamos los elementos verticalmente */
  align-items: center; /* Centramos horizontalmente */
  justify-content: center; /* Centramos verticalmente */
  text-align: center;
  gap: 0.75rem; /* Espacio entre el título y el indicador */
}

.plan-status-placeholder h3 {
  margin: 0;
  font-size: 1.1rem;
  color: #ccc;
  font-weight: normal;
  font-family: 'Share Tech Mono', monospace;
}

.plan-status-placeholder .status-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem; /* Espacio entre el punto y el texto */
  font-weight: bold;
  font-family: 'Share Tech Mono', monospace;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  width: 120px; /* Ancho fijo para consistencia */
}

.plan-status-placeholder .status-indicator.online {
  background-color: rgba(57, 255, 20, 0.15);
  color: #39ff14;
  border: 1px solid rgba(57, 255, 20, 0.4);
}

.plan-status-placeholder .status-indicator.offline {
  background-color: rgba(255, 49, 49, 0.15);
  color: #ff3131;
  border: 1px solid rgba(255, 49, 49, 0.4);
}

/* Punto LED dentro del indicador */
.plan-status-placeholder .status-indicator::before {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: currentColor; /* Hereda el color del texto (rojo o verde) */
  box-shadow: 0 0 8px currentColor;
}

.plan-status-placeholder .status-indicator.online::before {
  animation: pulse 1.5s infinite; /* Reutilizamos la animación de pulso */
}

.device-card.clickable {
  cursor: pointer;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.device-card.clickable:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 245, 255, 0.2), 0 0 20px rgba(255, 0, 255, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/DeviceCard.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,kDAAkD;EAClD,uCAAuC,EAAE,4BAA4B;EACrE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB,EAAE,+BAA+B;EACxD,kFAAkF;EAClF,2BAA2B;EAC3B,mCAAmC,EAAE,wBAAwB;EAC7D,cAAc;EACd,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+CAA+C;EAC/C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,yCAAyC,EAAE,uBAAuB;EAClE,4BAA4B,EAAE,6BAA6B;AAC7D;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAE,2BAA2B;EACtD,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,4BAA4B;EAC5B,8BAA8B,EAAE,0CAA0C;AAC5E;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc,EAAE,oBAAoB;EACpC,4BAA4B;AAC9B;;AAEA;EACE,cAAc,EAAE,cAAc;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc,EAAE,cAAc;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,mDAAmD;AACnD;EACE;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;EACA;IACE,mBAAmB;IACnB,8CAA8C;EAChD;EACA;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,8CAA8C;EAC9C,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,sBAAsB,EAAE,yCAAyC;EACjE,mBAAmB,EAAE,8BAA8B;EACnD,uBAAuB,EAAE,4BAA4B;EACrD,kBAAkB;EAClB,YAAY,EAAE,2CAA2C;AAC3D;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,sCAAsC;EACnD,iBAAiB;EACjB,yCAAyC;EACzC,sBAAsB;EACtB,mBAAmB;EACnB,YAAY,EAAE,iCAAiC;AACjD;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,wCAAwC;AAC1C;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B,EAAE,6CAA6C;EAC7E,gCAAgC;AAClC;;AAEA;EACE,8BAA8B,EAAE,uCAAuC;AACzE;;AAEA;EACE,eAAe;EACf,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,+EAA+E;AACjF","sourcesContent":["/* Estilos para el Mission Control Dashboard */\n.device-card {\n  /* Fondo oscuro y profundo de la sala de control */\n  background-color: rgba(26, 26, 46, 0.8); /* Fondo semi-transparente */\n  border: 1px solid #00f5ff;\n  border-radius: 15px;\n  padding: 20px;\n  margin: 15px;\n  width: calc(50% - 30px); /* Para dos tarjetas por fila */\n  box-shadow: 0 0 15px rgba(0, 245, 255, 0.3), inset 0 0 10px rgba(0, 245, 255, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px); /* Prefijo para Safari */\n  color: #ffffff;\n  font-family: 'Share Tech Mono', monospace;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.device-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(0, 245, 255, 0.2);\n  padding-bottom: 1rem;\n  margin-bottom: 1rem;\n}\n\n.device-header h3 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-family: 'Share Tech Mono', monospace; /* Fuente tecnológica */\n  text-shadow: 0 0 5px #00f5ff; /* Sutil brillo en el texto */\n}\n\n/* Indicador de estado LED parpadeante */\n.status-indicator {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background-color: #ff3131; /* Rojo Fallo por defecto */\n  box-shadow: 0 0 10px #ff3131;\n}\n\n.status-indicator.online {\n  background-color: #39ff14; /* Verde Eléctrico */\n  box-shadow: 0 0 15px #39ff14;\n  animation: pulse 1.5s infinite; /* Animación de pulso para estado online */\n}\n\n.device-body p {\n  margin: 0.5rem 0;\n  font-size: 0.9rem;\n  color: #ccc;\n}\n\n.device-body p span {\n  font-weight: bold;\n}\n\n.device-body p span.online {\n  color: #39ff14; /* Verde Eléctrico */\n  text-shadow: 0 0 3px #39ff14;\n}\n\n.device-body p span.offline {\n  color: #ff3131; /* Rojo Neón */\n  text-shadow: 0 0 3px #ff3131;\n}\n\n.chart-container {\n  margin-top: 1.5rem;\n}\n\n.chart-container h4 {\n  margin-bottom: 15px;\n  color: #00f5ff; /* Cian neón */\n  text-align: center;\n  font-weight: normal;\n  text-shadow: 0 0 5px #00f5ff;\n}\n\n/* Animación de pulso para el indicador de estado */\n@keyframes pulse {\n  0% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(57, 255, 20, 0.7);\n  }\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 10px 10px rgba(57, 255, 20, 0);\n  }\n  100% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(57, 255, 20, 0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.device-simulation {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 2rem;\n  align-items: flex-start;\n}\n\n.process-list h4, .cpu-chart h4 {\n  color: #bbb;\n  margin-bottom: 1rem;\n}\n\n.process-list ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  font-family: 'Courier New', Courier, monospace;\n  font-size: 0.9rem;\n}\n.process-list li {\n  padding: 0.2rem;\n  border-bottom: 1px dashed #444;\n}\n\n@media (max-width: 900px) {\n  .device-simulation {\n    grid-template-columns: 1fr;\n  }\n}\n\n.plan-status-placeholder {\n  background: #1a1a2e;\n  border: 1px solid rgba(0, 245, 255, 0.3);\n  border-radius: 16px;\n  padding: 1.5rem 1rem;\n  display: flex;\n  flex-direction: column; /* Apilamos los elementos verticalmente */\n  align-items: center; /* Centramos horizontalmente */\n  justify-content: center; /* Centramos verticalmente */\n  text-align: center;\n  gap: 0.75rem; /* Espacio entre el título y el indicador */\n}\n\n.plan-status-placeholder h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: #ccc;\n  font-weight: normal;\n  font-family: 'Share Tech Mono', monospace;\n}\n\n.plan-status-placeholder .status-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem; /* Espacio entre el punto y el texto */\n  font-weight: bold;\n  font-family: 'Share Tech Mono', monospace;\n  padding: 0.3rem 0.8rem;\n  border-radius: 20px;\n  width: 120px; /* Ancho fijo para consistencia */\n}\n\n.plan-status-placeholder .status-indicator.online {\n  background-color: rgba(57, 255, 20, 0.15);\n  color: #39ff14;\n  border: 1px solid rgba(57, 255, 20, 0.4);\n}\n\n.plan-status-placeholder .status-indicator.offline {\n  background-color: rgba(255, 49, 49, 0.15);\n  color: #ff3131;\n  border: 1px solid rgba(255, 49, 49, 0.4);\n}\n\n/* Punto LED dentro del indicador */\n.plan-status-placeholder .status-indicator::before {\n  content: '';\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: currentColor; /* Hereda el color del texto (rojo o verde) */\n  box-shadow: 0 0 8px currentColor;\n}\n\n.plan-status-placeholder .status-indicator.online::before {\n  animation: pulse 1.5s infinite; /* Reutilizamos la animación de pulso */\n}\n\n.device-card.clickable {\n  cursor: pointer;\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.device-card.clickable:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 20px rgba(0, 245, 255, 0.2), 0 0 20px rgba(255, 0, 255, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
